import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import Logo from "../components/Logo";

const Unsubscribe = () => {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [state, setState] = useState("loading"); // loading | success | error
    const [email, setEmail] = useState("");

    useEffect(() => {
        if (!token) {
            setState("error");
            return;
        }
        api.get(`/unsubscribe?token=${encodeURIComponent(token)}`)
            .then((r) => {
                setEmail(r.data.email || "");
                setState("success");
            })
            .catch(() => setState("error"));
    }, [token]);

    return (
        <div className="bg-black min-h-screen flex items-center justify-center px-6 py-20" data-testid="unsubscribe-page">
            <div className="w-full max-w-lg">
                <div className="text-center mb-10">
                    <Logo size={56} />
                    <div className="mt-4 font-display text-2xl tracking-[0.18em]">MINDWORKS</div>
                </div>

                <div className="border border-white/15 bg-[#0a0a0a] p-10 text-center">
                    {state === "loading" && (
                        <div className="font-stencil tracking-widest text-xs text-white/50 animate-pulse">
                            PROCESSING...
                        </div>
                    )}

                    {state === "success" && (
                        <>
                            <CheckCircle2 size={56} className="text-red-600 mx-auto" strokeWidth={1.5} />
                            <h1 className="mt-6 font-display text-3xl md:text-4xl uppercase tracking-tight leading-[0.95]">
                                You're <span className="text-red-600">unsubscribed.</span>
                            </h1>
                            {email && (
                                <p className="mt-4 text-white/60 text-sm font-stencil tracking-widest">{email}</p>
                            )}
                            <p className="mt-6 text-white/70 leading-relaxed">
                                You won't get any more emails from MindWorks. No hard feelings — the fight is yours, and you set the terms.
                            </p>
                            <p className="mt-3 text-white/50 text-sm italic">
                                The door's always open if you want to come back.
                            </p>
                        </>
                    )}

                    {state === "error" && (
                        <>
                            <XCircle size={56} className="text-red-600 mx-auto" strokeWidth={1.5} />
                            <h1 className="mt-6 font-display text-3xl md:text-4xl uppercase tracking-tight leading-[0.95]">
                                Link <span className="text-red-600">Invalid.</span>
                            </h1>
                            <p className="mt-6 text-white/70 leading-relaxed">
                                This unsubscribe link is broken or expired. Please reply to the original email and we'll take you off manually.
                            </p>
                        </>
                    )}

                    <div className="mt-10 flex flex-wrap gap-3 justify-center">
                        <Link to="/" className="btn-ghost text-xs" data-testid="unsub-home-link">
                            Back to Home <ArrowUpRight size={14} />
                        </Link>
                    </div>
                </div>

                <div className="mt-8 text-center text-xs text-white/30 font-stencil tracking-widest">
                    2 CORINTHIANS 10:5
                </div>
            </div>
        </div>
    );
};

export default Unsubscribe;
